export default ({ submitting, pristine, errors, submitErrors, dirtySinceLastSubmit }) => (
  submitting ||
  pristine ||
  (errors && !!Object.keys(errors).length) ||
  (submitErrors && !!Object.keys(submitErrors).length && !dirtySinceLastSubmit)
);